import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { PageHeader } from "../../layout/AppLayout";
import { ErpTable } from "../../components/erp";
import { errorText } from "../../api/client";
import { TrackRow, tracksApi } from "./api";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

/** PreProcessing dashboard/list — reads RmReceivingDetails, the row every downstream stage (Deheading,
 * Grading, Value-Addition) keys off via its ReceivingID/TrackID. No single current legacy "dashboard" page
 * was identified for the TrackID generation; this is a composed read of that table (see MIGRATION.md). */
export default function TracksList() {
  const now = new Date();
  const [month, setMonth] = useState(String(now.getMonth() + 1));
  const [year, setYear] = useState(String(now.getFullYear()));
  const list = useQuery({ queryKey: ["pp", "tracks", month, year], queryFn: () => tracksApi.list({ Month: month, Year: year }) });

  return (
    <>
      <PageHeader title="PreProcessing Tracks" location="Preprocessing" />
      <div className="card"><div className="card-body">
        <div className="row rowFilter mb-3">
          <div className="col-md-3">
            <select className="form-select" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="tracks-month">
              {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
            </select>
          </div>
          <div className="col-md-3">
            <input className="form-control" type="number" value={year} onChange={(e) => setYear(e.target.value)} data-testid="tracks-year" />
          </div>
          <div className="col-md-3 ms-auto">
            <Link className="btn btn-success w-100" to="/v3/PreProcessing/receival-page-trackid" data-testid="tracks-new-receival">+ New Receival</Link>
          </div>
        </div>
        <ErpTable<TrackRow> testId="tracks-table" loading={list.isLoading}
          error={list.isError ? errorText(list.error) : list.data?.Error || null} rows={list.data?.Data || []}
          columns={[
            { key: "TrackCode", title: "Track Code" }, { key: "ArrivalDate", title: "Date" }, { key: "PlantName", title: "Plant" },
            { key: "VehicleNumber", title: "Vehicle" }, { key: "SealNo", title: "Seal No" }, { key: "SupervisorName", title: "Supervisor" },
            { key: "Action", title: "Action", render: (r) => (
              <div className="d-flex gap-1">
                <Link className="btn btn-sm btn-outline-primary" data-testid={`track-deheading-${r.TrackID}`} to={`/v3/PreProcessing/de-heading-trackid?TrackID=${r.TrackID}`}>Deheading</Link>
                <Link className="btn btn-sm btn-outline-primary" data-testid={`track-va-${r.TrackID}`} to={`/v3/PreProcessing/value-addition-trackid?TrackID=${r.TrackID}&PlantID=${r.ReceivingPlantID}`}>Value Addn</Link>
              </div>
            ) },
          ]} />
      </div></div>
    </>
  );
}
